/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const transitionDelay = 0

exports.shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.hash) {
    return false
  }

  if (location.action === 'PUSH') {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDelay)
  } else {
    const savedPosition = getSavedScrollPosition(location)
    window.setTimeout(
      () => window.scrollTo(...(savedPosition || [0, 0])),
      transitionDelay
    )
  }
  return false
}

const HEADER_OFFSET = 74 // matches gatsby-plugin-anchor-links offset
const scrollToHash = hash => {
  const id = hash.replace(/^#/, '')
  const el = document.getElementById(id)
  if (!el) return false
  const y = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET
  window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' })
  return true
}
exports.onRouteUpdate = ({ location }) => {
  if (!location.hash) return
  if (scrollToHash(location.hash)) return
  let attempts = 0
  const retry = window.setInterval(() => {
    attempts += 1
    if (scrollToHash(location.hash) || attempts > 20) {
      window.clearInterval(retry)
    }
  }, 50)
}
